import { transformFirstLetterToUpperCase } from '@/core/helpers/utils';
import type {
  IVatTuXuatKhoResponseBase,
  ReceiptBaseResponse,
} from '@/core/interfaces/ApiResponses';
import ToolService from '@/core/services/Tool.service';
import { VatTuService } from '@/core/services/VatTu.service';
import type { IPhieuXuatKhoSelectedKhoSummary } from '../types';
import { calcThanhTienTotal } from './phieuXuatKhoCalculations';

export async function buildPhieuXuatKhoSummaryGroups(
  phieuXuat: Pick<ReceiptBaseResponse, 'kho' | 'vat_tu_xuat_kho'>,
  vatTuSelected: IVatTuXuatKhoResponseBase[] = []
): Promise<IPhieuXuatKhoSelectedKhoSummary[]> {
  const group: IPhieuXuatKhoSelectedKhoSummary = {
    ten_kho: phieuXuat.kho?.ten_kho ?? '',
    tong_tien: 0,
    tong_tien_bang_chu: '',
    vat_tu_da_lay: [],
  };

  if (!phieuXuat.vat_tu_xuat_kho.length) {
    return [group];
  }

  let vatTuTrongKho: Awaited<
    ReturnType<typeof VatTuService.getVatTuInKho>
  >['data']['data']['data'] = [];

  if (phieuXuat.kho?.id) {
    const phieuXuatVatTuIds = new Set(
      phieuXuat.vat_tu_xuat_kho.map(({ id }) => id)
    );
    const selectedVatTuIdsInPhieuXuat = vatTuSelected
      .map(({ id }) => id)
      .filter((id) => phieuXuatVatTuIds.has(id));

    const {
      data: {
        data: { data },
      },
    } = await VatTuService.getVatTuInKho({
      idKho: phieuXuat.kho.id,
      vat_tu_ids: selectedVatTuIdsInPhieuXuat,
    });

    vatTuTrongKho = data;
  }

  for (const vatTu of phieuXuat.vat_tu_xuat_kho) {
    const soLuongConLai = vatTuTrongKho.find(({ id }) => id === vatTu.id)?.pivot
      .so_luong;

    group.vat_tu_da_lay.push({
      ten_vat_tu: vatTu.ten_vat_tu,
      ma_vat_tu: vatTu.ma_vat_tu,
      so_luong_lay: +vatTu.pivot.so_luong,
      don_gia: +(vatTu.pivot.don_gia ?? 0),
      con_lai: soLuongConLai ? +soLuongConLai : 0,
      don_vi_tinh: vatTu.don_vi_tinh,
      ghi_chu: vatTu.pivot.ghi_chu,
      thu_hoi: vatTu.thu_hoi,
      sl_tai_sd: vatTu.pivot.sl_tai_sd,
      sl_mat: vatTu.pivot.sl_mat,
      sl_phe_lieu: vatTu.pivot.sl_phe_lieu,
      kg_phe_lieu: vatTu.pivot.kg_phe_lieu,
      ma_vt_thu_hoi: vatTu.vat_tu_thu_hoi?.ma_vat_tu || '',
    });
  }

  const tongTien = calcThanhTienTotal(group.vat_tu_da_lay);

  group.tong_tien = tongTien;

  if (tongTien > 0) {
    const {
      data: { data },
    } = await ToolService.convertPriceToText(tongTien);

    group.tong_tien_bang_chu = transformFirstLetterToUpperCase(data);
  }

  return [group];
}
